/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SecurityPolicyControllerUpdatePolicyRequest { 
    requiresEmailVerification?: boolean | null;
    requires2fa?: boolean | null;
    /**
     * Permite passkeys. null = heredar; sin definir en ningún scope = no.
     */
    allowPasskeys?: boolean | null;
    /**
     * Dónde aplica la verificación de correo. null = todas / heredar.
     */
    emailVerificationPlatforms?: Array<SecurityPolicyControllerUpdatePolicyRequest.EmailVerificationPlatformsEnum> | null;
}
export namespace SecurityPolicyControllerUpdatePolicyRequest {
    export type EmailVerificationPlatformsEnum = 'web' | 'ios' | 'android';
    export const EmailVerificationPlatformsEnum = {
        Web: 'web' as EmailVerificationPlatformsEnum,
        Ios: 'ios' as EmailVerificationPlatformsEnum,
        Android: 'android' as EmailVerificationPlatformsEnum
    };
}


